import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from "@angular/material";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Subject } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

import { EnquiryService } from "../shared/enquiry.service";
import { SnackBarService } from "../../core/snack-bar.service";

import { EmailHistoryDialogComponent } from "../email-history-dialog/email-history-dialog.component";
import { EnquiryListing } from "../shared/enquiry-listing.model";

@Component({
    template: require('./enquiry-list.component.html'),
    styles: [require('./enquiry-list.component.css')]
})
export class EnquiryListComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns =
        ["enquiryNumber", "businessName", "contactName", "product", "costOfGoods",
        "term", "repayment", "createdOn", "lastEmailSentOn", "submittedOn", "actions"];
    dataSource: MatTableDataSource<EnquiryListing>;
    filterFC: FormControl;
    loading: boolean;
    monthsAgoFC: FormControl;
    monthOptions: number[];

    private ngUnsubscribe: Subject<void> = new Subject(); //see https://stackoverflow.com/a/41177163

    constructor(
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        private enquiryService: EnquiryService,
        private router: Router,
        private snackBarService: SnackBarService) {

        this.monthsAgoFC = new FormControl();
        this.filterFC = new FormControl();
        this.monthOptions = [1, 3, 6, 12];
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.monthsAgoFC.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(val => {
                this.getEnquiries(val);
            });

        this.filterFC.valueChanges
            .pipe(
                takeUntil(this.ngUnsubscribe),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe(val => {
                this.dataSource.filter = val;
            });

        this.monthsAgoFC.setValue(12);

        this.activatedRoute.paramMap
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((params: ParamMap) => this.filterFC.setValue(params.get("search")), err => console.log(err));
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getEnquiries(monthsAgo: number): void {
        this.loading = true;
        this.enquiryService.getListing(monthsAgo)
            .then(data => {
                this.loading = false;
                this.dataSource.data = data;
            })
            .catch(err => {
                this.loading = false;
                this.snackBarService.openSnackBar(err);
            });
    }

    goToEnquiry(enquiryID: number): void {
        this.router.navigate(["enquiries", enquiryID]);
    }

    goToNewEnquiry(): void {
        this.router.navigate(["enquiries/new"]);
    }

    openEmailHistoryDialog(enquiryID: number) {
        let dialogRef = this.dialog.open(EmailHistoryDialogComponent, {
            width: "800px",
            data: {
                enquiryID: enquiryID
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/enquiry-list/enquiry-list.component.ts